import React from 'react';
import { Box } from '../../../../base/Box/Box';
import { CompanyIntroLogoCardStoryblok } from '../../../../types/storyblok';
import { StoryblokImage } from '../../../../base/StoryblokImage/StoryblokImage';

export const UnamedSectionLogoCard = ({
  logo,
}: CompanyIntroLogoCardStoryblok) => {
  if (!logo) {
    return null;
  }

  return (
    <Box as="article" className="mx-10 md:mx-15" overlayOverBkg>
      <StoryblokImage
        src={logo}
        mode="responsive"
        maxWidth={100}
        alt=""
        className="h-13"
      />
    </Box>
  );
};

export default UnamedSectionLogoCard;
